import { render, staticRenderFns } from "./ServiceItemLandscape.vue?vue&type=template&id=03936850&scoped=true&"
import script from "./ServiceItemLandscape.vue?vue&type=script&lang=js&"
export * from "./ServiceItemLandscape.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemLandscape.vue?vue&type=style&index=0&id=03936850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03936850",
  null
  
)

export default component.exports